<template>
	<div class="shift-color-filter d-flex align-center">
		<div class="shift-color-filter__group">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						icon
						depressed
						:class="['shift-color-filter__btn', 'shift-color-filter__btn--blue', { 'shift-color-filter__btn--active': filter.blue }]"
						@click="toggle('blue')"
					>
						<v-icon size="21">mdi-calendar-plus</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('modules.customdata.shift_color_filter.blue') }}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						icon
						depressed
						:class="['shift-color-filter__btn', 'shift-color-filter__btn--green', { 'shift-color-filter__btn--active': filter.green }]"
						@click="toggle('green')"
					>
						<v-icon size="21">mdi-calendar-check</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('modules.customdata.shift_color_filter.green') }}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						icon
						depressed
						:class="['shift-color-filter__btn', 'shift-color-filter__btn--red', { 'shift-color-filter__btn--active': filter.red }]"
						@click="toggle('red')"
					>
						<v-icon size="21">mdi-calendar-remove</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('modules.customdata.shift_color_filter.red') }}</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						icon
						depressed
						:class="['shift-color-filter__btn', 'shift-color-filter__btn--gray', { 'shift-color-filter__btn--active': filter.gray }]"
						@click="toggle('gray')"
					>
						<v-icon size="21">mdi-calendar-minus</v-icon>
					</v-btn>
				</template>
				<span>{{ $t('modules.customdata.shift_color_filter.gray') }}</span>
			</v-tooltip>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'ShiftColorFilter',

	computed: {
		...mapGetters(['custom_data_shift_color_filter']),

		filter() {
			return this.custom_data_shift_color_filter || {
				blue: true,
				green: true,
				red: true,
				gray: true,
			};
		},
	},

	mounted() {
		this.$store.dispatch('customDataLoadShiftColorFilter');
	},

	methods: {
		...mapActions(['customDataSetShiftColorFilter']),

		toggle(category) {
			const current = this.filter[category];
			this.customDataSetShiftColorFilter({ [category]: !current });
			this.$emit('change');
		},
	},
};
</script>

<style lang="scss" scoped>
.shift-color-filter {
	&__group {
		display: flex;
		border: 1px solid rgba(0, 0, 0, 0.38);
		border-radius: 4px;
		overflow: hidden;
	}

	&__btn {
		min-width: 38px !important;
		width: 38px !important;
		height: 38px !important;
		border-radius: 0;
		border-right: 1px solid rgba(0, 0, 0, 0.12);

		&:last-child {
			border-right: none;
		}

		&::before {
			background-color: transparent !important;
		}

		&--active {
			&.shift-color-filter__btn--blue {
				background-color: #1976d2 !important;
			}

			&.shift-color-filter__btn--green {
				background-color: #4caf50 !important;
			}

			&.shift-color-filter__btn--red {
				background-color: #f44336 !important;
			}

			&.shift-color-filter__btn--gray {
				background-color: #616161 !important;
			}

			color: white !important;

			::v-deep .v-icon {
				color: white !important;
			}
		}

		&:not(.shift-color-filter__btn--active) {
			background-color: white !important;

			::v-deep .v-icon {
				color: rgba(0, 0, 0, 0.8) !important;
			}
		}
	}
}
</style>
